<!-- src/tilelist/components/benefit-cinema/BenefitCinemaProvider.svelte -->
<script lang="ts">
    import type { Snippet } from 'svelte';
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    import { setContext } from 'svelte';
    import { injectProviderComposition } from '@tilelist/components/ProviderComposition.svelte.ts';
    import { BENEFIT_CINEMA_CONTEXT } from './BenefitCinemaStore.svelte.ts';

    interface Props {
        rule: string;
        /*                                                                              */
        storeEnabled?: boolean;
        children?: Snippet;
    }

    let { rule, storeEnabled = true, children }: Props = $props();

    /*                                                                              */
    /*                                    */
    /*                                     */
    const composition = injectProviderComposition();
    /*                                     */
    const store = storeEnabled ? composition.createBenefitCinemaStore() : undefined;
    if (store) setContext(BENEFIT_CINEMA_CONTEXT, store);

    /*                                                                            */
    /*                                                                */
    /*                                     */
    let previousRule = rule;

    $effect(() => {
        if (!store) return;
        if (rule === previousRule) return;
        previousRule = rule;
        store.fetch(rule);
    });
</script>

{#if children}{@render children()}{/if}
